
export function state() {
  return {
    notificationToShow: null,
  };
}

export const mutations = {
  showSuccessNotification(state, {message, title}) {
    state.notificationToShow = {
      id: Math.round(Math.random() * 10000),
      title: title,
      message: message,
    };
  },

  showErrorNotification(state, {message, title}) {
    state.notificationToShow = {
      id: Math.round(Math.random() * 10000),
      title: title,
      message: message,
    };
  },

  clearNotification(state) {
    state.notifictionToShow = null;
  }
};

export const actions = {};

export const getters = {
  notificationToShow(state, getters) {
    return state.notificationToShow;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
